
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import ImagesPreview from '../../../../core/components/Generics/Images/ImagesPreview.vue'
import { formatDate } from '../../../../core/utils/date-handlers';
import { Note } from '../../../../typescript/notes/notes';

@Component({
  components: {
    ImagesPreview
  }
})
export default class ModalNoteInfoMap extends Vue {
  @Prop() visible: boolean;
  @Prop({ default: null }) noteInfo: Note | any;

  /** Badges only when notes were enriched under CLAIM privilege */
  get showSamplingBadges(): boolean {
    return !!(
      this.noteInfo &&
      this.noteInfo.sampling != null &&
      Object.prototype.hasOwnProperty.call(this.noteInfo, 'sampling_classification_name')
    );
  }

  get displayNoteText(): string {
    const text = this.noteInfo && this.noteInfo.text;
    return text != null && String(text).trim() !== '' ? text : '-';
  }

  get muestraChipStyle(): Record<string, string> {
    const color =
      (this.noteInfo && this.noteInfo.sampling_marker_color) || '#1976D2';
    return { backgroundColor: color, borderColor: color };
  }

  @Emit()
  closeModal() {}

  parseDate(date){
    return formatDate(date)
  }
}
